import { MembershipsCreatorApiClient } from '@fourthwall/services/dist/MembershipsCreatorApiClient'
import { createMutationHook } from '@fourthwall/utils'

export const useUpdateGeneralSettingsMutation = createMutationHook(
  MembershipsCreatorApiClient.updateGeneralSettings,
  {
    mutationKey: ['updateGeneralSettings'],
  },
)
